import { fetcher } from '@/src/general/utilities/fetcher'

import type { TBecomeWatchmanData, TBecomeWatchmanPayload } from './types/becomeWatchman.types'

export const watchmanApi = {
  becomeWatchman: (payload: TBecomeWatchmanPayload) =>
    fetcher.mutate<TBecomeWatchmanData, TBecomeWatchmanPayload>('/watchman', payload, { method: 'POST' }),
}
